/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum TreeType {
    GEO_TREE = 'GeoTree',
    SECTOR_SETUP = 'SectorSetup',
    BUILDING_TYPE = 'BuildingType',
    BUILDING_ATTRIBUTE = 'BuildingAttribute',
    UNIT_TYPE = 'UnitType',
}
